import { colord, Colord, extend } from 'colord'
import a11yPlugin from 'colord/plugins/a11y'

extend([a11yPlugin])

export const AKIXI_COLOUR_WHITE: string = '#FFFFFF'
export const AKIXI_COLOUR_OXFORD_BLUE: string = '#00001e'
export const AKIXI_COLOUR_ELECTRIC_INDIGO: string = '#4450ff'
export const AKIXI_COLOUR_VIVID_SKY: string = '#1cd2fa'
export const AKIXI_COLOUR_VIVID_SKY_DARK: string = '#4cc7cf'
export const AKIXI_COLOUR_ELECTRIC_INDIGO_LIGHT: string = '#3a69f1'
export const AKIXI_COLOUR_AQUAMARINE: string = '#22f4ad'
export const AKIXI_COLOUR_INSIGHTS_RED: string = '#ee504d'

export const AKIXI_COLOUR_SUCCESS: string = '#009b66'
export const AKIXI_COLOUR_ERROR: string = '#ff0033'

/**
 * Pick a colour that contrasts with the given colour
 *
 * @param colour - The colour to contrast
 * @param dark - The dark colour to contrast with
 * @param light - The light colour to contrast with
 */
export const colourContrast = (
    colour: string,
    dark: string = AKIXI_COLOUR_OXFORD_BLUE,
    light: string = AKIXI_COLOUR_WHITE
): string => {
    // Pick a colour that contrasts with the given colour
    const colordColor: Colord = colord(colour)
    const colordDark: Colord = colord(dark)
    const colordLight: Colord = colord(light)

    return (colordColor.contrast(colordDark) > colordColor.contrast(colordLight) ? colordDark : colordLight).toHex()
}

/**
 * Lighten or darken a colour based on contrast
 *
 * @param colour - The colour to lighten or darken
 * @param amount - The amount to lighten or darken the colour
 */
export const lightenOrDarken =
    (amount: number) =>
    (colour: string): string => {
        const colordColor: Colord = colord(colour)
        const lightened: Colord = colordColor.lighten(amount)
        const darkened: Colord = colordColor.darken(amount)

        return colourContrast(colour, darkened.toHex(), lightened.toHex())
    }
